export default __webpack_public_path__ + "static/media/playstore.b1dfdf52.png";